import { type FC } from 'react';
import { StyledSection, StyledTitle, StyledTypography } from '../styles';
import type { HeroProps } from './Hero.types';
import {
  HeroSectionContainer,
  HeroSectionColumn,
  LocationsWrapper,
  StyledJobDescription,
  StyledImage,
  SalariesWrapper,
  StyledButton,
} from './styles';

export const Hero: FC<HeroProps> = ({
  title,
  shortDescription,
  heroImage,
  locations,
  salaries,
  onApply,
}) => {
  return (
    <StyledSection width="normal" mobilePadding>
      <HeroSectionContainer>
        <HeroSectionColumn>
          <StyledTypography variant="regular_600">
            Join our team as:
          </StyledTypography>
          <StyledTitle variant="display_sm">{title}</StyledTitle>
          <LocationsWrapper>
            {locations?.map((location, index) => (
              <>
                <StyledTypography key={location} variant="regular_500">
                  {location}
                </StyledTypography>
                {index < locations.length - 1 && (
                  <StyledTypography key={index} variant="regular_500">
                    |
                  </StyledTypography>
                )}
              </>
            ))}
          </LocationsWrapper>
          <StyledJobDescription variant="regular_400">
            {shortDescription}
          </StyledJobDescription>
        </HeroSectionColumn>
        <HeroSectionColumn>
          <StyledImage src={heroImage} alt={title ?? ''} />
          <SalariesWrapper>
            {salaries?.map((salary) => (
              <StyledTypography key={salary} variant="regular_500">
                {salary}
              </StyledTypography>
            ))}
          </SalariesWrapper>
          <StyledButton secondaryVariant shadowColor="orange" onClick={onApply}>
            Apply
          </StyledButton>
        </HeroSectionColumn>
      </HeroSectionContainer>
    </StyledSection>
  );
};
